import { render, staticRenderFns } from "./performance-statistics_division.vue?vue&type=template&id=6d79cba2&scoped=true&"
import script from "./performance-statistics_division.vue?vue&type=script&lang=js&"
export * from "./performance-statistics_division.vue?vue&type=script&lang=js&"
import style0 from "./performance-statistics_division.vue?vue&type=style&index=0&id=6d79cba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d79cba2",
  null
  
)

export default component.exports